import { render, staticRenderFns } from "./dialog-logout.vue?vue&type=template&id=18f3d50d&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-logout.vue"
export default component.exports